export const TEAMS_RESOURCE_TYPES: string[] = ['message', 'conversation', 'video'];
